export const iconFontAwesomeWritingFolderOpen = (
	<i className="fa-solid fa-folder-open"></i>
);
